module.exports = __webpack_public_path__ + "media/images/CrossElasticity-d14da5f4407d5e2d9b881bd1632357ab.png";